import React, { useEffect } from 'react'
import { StyledToastPortal } from './styles.js'
import PropTypes from 'prop-types'

export const ToastPortal = ({ children }) => {
  useEffect(() => {
    const mainElement = document.querySelector('main')
    const toastPortal = document.createElement('div')
    if (mainElement) {
      mainElement.appendChild(toastPortal)
    }
  }, [])
  return <StyledToastPortal className='bq-toast-portal top-center'>{children}</StyledToastPortal>
}

ToastPortal.propTypes = {
  children: PropTypes.node.isRequired
}
export default ToastPortal
